export default {
  agent: '成为四维看看经销商',
  agentIntro: '四维看看致力于构造一个“数字万物”的生态系统，让每个人都能体验及享受到AI计算机视觉带来的便利。<br/>我们诚邀您加入我们的经销商团队，成为我们的一员。',
  project: {
    title: '四维看看经销商计划概述',
    label:
      '四维时代独创的AI空间重构算法技术已屡获殊荣，并累计在全球范围采集超过30万个空间模型。<br/>这种全新的空间记录方式正在逐步改变各行各业的业务模式（房地产、建筑、文博、旅游、新闻、保险理赔、刑侦记录等等）。<br/>四维看看经销商计划诚邀各业界专业人士，参与到未来的“数字万物”的进程中，共同开拓市场，分享利润。<br/>如果您对3D捕捉世界的想法很感兴趣，并愿将其纳入到您的事业规划中，这是一个绝佳的合作机会。'
  },
  benefit: '成为增值经销商的好处',
  benefitGroup: [
    {
      fontImg: 'icon-lirunfencheng',
      title: '利润分成',
      sub: '丰厚的利润分成'
    },
    {
      fontImg: 'icon-zhuanshukefu',
      title: '专属客服',
      sub: '提供专属的专业的销售<br/>与技术人员'
    },
    {
      fontImg: 'icon-xuanchuanziliao',
      title: '宣传资料',
      sub: '定期更新的宣传视频<br/>及宣传案例'
    },
    {
      fontImg: 'icon-dianmianbuzhi',
      title: '店面布置',
      sub: '支持店面必要的<br/>广告物料'
    },
    {
      fontImg: 'icon-fazhanjihui',
      title: '发展机会',
      sub: '参与营销与<br/>科技大会的机会'
    }
  ],
  jingxiaoshang: {
    title: '成为四维看看经销商',
    companytitle: '公司信息',
    company: {
      name: {
        title: '公司注册名称',
        placeholder: '请输入公司注册名称'
      },
      address: {
        title: '公司地址',
        placeholder: '国家',
        placeholder2: '地区',
        placeholder3: '请输入公司地址'

      },
      store: {
        title: '是否有门店或企业网站',
        type1: '线下销售为主',
        type2: '线上销售为主',
        placeholder: '请输入门店详细地址'
      }
    },
    applytitle: '申请人信息',
    apply: {
      name: {
        xing: '姓',
        ming: '名',
        placeholder: '请输入姓',
        placeholder1: '请输入名'
      },
      position: {
        title: '职位',
        placeholder: '请输入职位'
      },
      phone: {
        title: '电话',
        placeholder: '请输入电话'
      },
      email: {
        title: '电子邮箱',
        placeholder: '请输入电子邮箱'
      }
    }
  },
  submit: '提交'
}



// WEBPACK FOOTER //
// ./src/store/language/cn/agent.js